import Vue from 'vue';
import VueMeta from 'vue-meta';
import VueRouter from 'vue-router';
import Faq from '@/views/FAQNew.vue';
import Invalid from '@/views/Invalid.vue';
import FaqApp from '@/views/app/FAQ.vue';
import HowItWorksApp from '@/views/app/HowItWorks.vue';
import TermsApp from '@/views/app/Terms.vue';
import PrepaymentApp from '@/views/app/Prepayment.vue';
import Feedback from '@/views/Feedback.vue';
import ProjectsOverview from '@/views/ProjectsOverview.vue';
import ProjectsOverviewNew from '@/views/ProjectsOverviewNew.vue';
import ProjectInfo from '@/views/ProjectInfo.vue';
import HowItWorks from '@/views/HowItWorksNew.vue';
import PaymentHistoryPrint from '@/views/PaymentHistoryPrint.vue';
import AccountHistory from '@/views/AccountHistory.vue';
import AccountSettings from '@/views/AccountSettings.vue';
import AccountBenefits from '@/views/AccountBenefits.vue';
import AccountRefill from '@/views/AccountRefill.vue';
import Terms from '@/views/TermsNew.vue';
import Login from '@/views/Login.vue';
import Payment from '@/views/Payment.vue';
import AppPayment from '@/views/app/Payment.vue';
import ForgotPassword from '@/views/ForgotPassword.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import Dashboard from '@/views/Dashboard.vue';
import ManageProjects from '@/views/admin/ManageProjects.vue';
import Smartsvar from '@/views/Smartsvar.vue';
import Forbidden from '@/views/403.vue';
import Error from '@/views/404.vue';
import store from '../store/store';

Vue.use(VueRouter);
Vue.use(VueMeta);

const routes = [
  {
    path: '/',
    redirect: '/overview/',
    name: 'Root',
  },
  {
    path: '/overview-old/:api_token?/:filter?/:payment_confirm?',
    name: 'Projects overview old',
    component: ProjectsOverview,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/overview/:api_token?/:filter?/:payment_confirm?',
    name: 'Projects overview',
    component: ProjectsOverviewNew,
    meta: {
      requiresAuth: true,
    },
  },
  {
    //Redirect old location to new
    path: '/view-project/:id/:api_token?',
    redirect: '/lead/:id/edit/:api_token?',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/lead/:id/:method/:api_token?',
    name: 'View lead',
    component: ProjectInfo,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/faq',
    name: 'Faq',
    component: Faq,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/invalid/:reason',
    name: 'Invalid',
    component: Invalid,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/app/faq/:com_only?',
    name: 'Faq App',
    component: FaqApp,
  },
  {
    path: '/app/how-it-works/:com_only?',
    name: 'How it works App',
    component: HowItWorksApp,
  },
  {
    path: '/app/terms/:lang/:country/:com_only?',
    name: 'Terms App',
    component: TermsApp,
  },
  {
    path: '/app/prepayment',
    name: 'Prepayment App',
    component: PrepaymentApp,
  },
  {
    path: '/feedback/:user_token?',
    name: 'Feedback',
    component: Feedback,
  },
  {
    path: '/pay/:userId?',
    name: 'Payment',
    component: Payment,
  },
  {
    path: '/app/pay/:userId',
    name: 'Payment',
    component: AppPayment,
  },
  {
    path: '/refill/:api_token?',
    name: 'Refill',
    component: AccountRefill,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/smartsvar/:api_token?',
    name: 'Smartsvar',
    component: Smartsvar,
  },
  {
    path: '/how-it-works',
    name: 'How it works',
    component: HowItWorks,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/terms-conditions',
    name: 'Terms',
    component: Terms,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/app/account/payment-history/:api_token?',
    name: 'Payment history',
    component: PaymentHistoryPrint,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/app/account/history/:api_token?',
    name: 'Account history temp app',
    component: AccountHistory,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/history/:api_token?',
    name: 'Account history',
    component: AccountHistory,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/settings/:api_token?',
    name: 'Account settings',
    component: AccountSettings,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/account/benefits/:api_token?',
    name: 'Account benefits',
    component: AccountBenefits,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/:api_token?',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/admin/manage-projects',
    name: 'Manage projects',
    component: ManageProjects,
    beforeEnter: (to, from, next) => {
      if (store.state.user.adminUser && sessionStorage.getItem('api_token')) {
        next();
      } else {
        next({ name: 'Login' });
      }
    },
  },
  {
    path: '/login/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/forgot-password/',
    name: 'Forgot password',
    component: ForgotPassword,
  },
  {
    path: '/reset-password/:api_token?',
    name: 'Reset password',
    component: ResetPassword,
    meta: {
      requiresAuth: true,
    },
  },
  {
    //Logout handled by middleware
    path: '/logout/',
    name: 'Logout',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/403/',
    name: 'Forbidden',
    component: Forbidden,
  },
  {
    path: '/404/',
    name: 'Not found',
    component: Error,
  },
  {
    path: '*',
    redirect: '/404/',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
  },
});

router.beforeEach((to, from, next) => {
  if (to.params.api_token) {
    sessionStorage.setItem('api_token', decodeURI(to.params.api_token));
    store.dispatch('getUser');
  }
  if (
    to.matched.some((record) => record.name == 'Login') &&
    sessionStorage.getItem('api_token')
  ) {
    next({ name: 'Root' });
  }
  if (
    to.matched.some((record) => record.name == 'Logout') &&
    sessionStorage.getItem('api_token')
  ) {
    store.dispatch('removeUserData');
    next({ name: 'Login' });
  }
  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !sessionStorage.getItem('api_token')
  ) {
    next({ name: 'Login' });
  } else {
    next();
  }
  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    sessionStorage.getItem('api_token')
  ) {
    store.dispatch('getUser');
    next();
  } else {
    next();
  }
});

export default router;
